import { usePageContext } from '@internal/page/PageContext'
import { useCallback } from 'react'
import { formatPrice } from '../numbers/formatPrice'
import { Machine } from './Machine'
import { useMachineTypeName } from './useMachineTypeName'

export const useMachineImageAltText = () => {
  const { getMachineTypeName } = useMachineTypeName()
  const { locale } = usePageContext()

  const getMachineImageAltText = useCallback(
    (machine: Machine) => {
      return `${machine.name} ${getMachineTypeName(machine.machineType, 'singular')} ${machine.price ? formatPrice(locale, machine.price) : ''}`.trim()
    },
    [getMachineTypeName, locale]
  )

  return { getMachineImageAltText }
}
